// @flow

import * as React from 'react';
import ObfuscatedLink from '@ta/common.obfuscated-link';
import Separator from './Separator';
import type { SimpleLink } from './SimpleLinkSection';
import styles from './HorizontalLinkSection.less';

type Props = {|
  links: SimpleLink[],
|};

/** A list of simple horizontal links for the footer */
const HorizontalLinkSection = ({ links }: Props) => {
  const linkList = links.map((link, index) => (
    <React.Fragment key={link.url}>
      <ObfuscatedLink
        encodedUrl={link.url}
        useSpan
        className={styles.ui_link}
        target={link.newWindow ? '_blank' : '_self'}
      >
        {link.text}
      </ObfuscatedLink>
      <Separator index={index} size={links.length} separator=" | " />
    </React.Fragment>
  ));

  return <div className={`is-hidden-mobile ${styles.footer_links}`}>{linkList}</div>;
};

export default HorizontalLinkSection;
